import { AnySchema } from 'ajv';

import { DateFilterFields } from '../../dateFilter.models';

export const dateRangeFilterSchema: AnySchema | any = {
  type: 'object',
  properties: {
    [DateFilterFields.From]: {
      type: 'string',
      format: 'date',
    },
    [DateFilterFields.To]: {
      type: 'string',
      format: 'date',
    },
  },
  required: [DateFilterFields.To, DateFilterFields.From],
};
